export const stringsKey = "BatchMessageDetailPreview";
export const englishStrings = {
	phoneNumberLabel: "Input phone number to send a test message",
	addButtonText: "Add",
	removeNumberToolTip: "Remove Number",
	previewMessageSegmentToolTip: "Preview Message Segment",
	dynamicVariablesPresent:
		"Your messages contain dynamic variables. These will not be replaced during this testing stage.",
};
